<!-- The left-hand camera, always grey: the item is/was/will be online (online-only or also on
     site); before the event it signs in or joins. No icon: not online. A recording is the play
     icon at the end of the item (TableRows), not a colour here (Seán, 2026-10-29). -->
<template>
  <template v-if="isOnline">
    <a v-if="clickTarget" @click.prevent="handleClick">
      <img :src="onlineIconSrc" :title="activeTitle" />
    </a>
    <img v-else :src="onlineIconSrc" :title="ONLINE_TITLE" />
  </template>
</template>

<script setup>
import {computed} from "vue";
import {useRouter} from "vue-router";
import useUserSafe from "@/composables/useUserSafe";

const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
const props = defineProps(["event", "align", "joinLink"]);

const router = useRouter();
const {isSignedIn} = useUserSafe();

const ONLINE_TITLE = "Online event.";
const onlineIconSrc = require("@/assets/img/onsite+online.png"); // grey

const isOnline = computed(() => /online/i.test(props.event.mode || ""));

const isPast = computed(() => {
  if (!props.event?.start?.toMillis) return false;
  const end = props.event.end || props.event.start;
  return Date.now() > end.toMillis();
});

const clickTarget = computed(() => {
  if (isPast.value) return null;
  if (!isSignedIn.value) return "sign-in";
  if (props.joinLink) return props.joinLink;
  return null;
});

const activeTitle = computed(() => {
  if (!isSignedIn.value) return `${ONLINE_TITLE} Sign in to join online.`;
  return `${ONLINE_TITLE} Click to join online.`;
});

function handleClick() {
  if (!isSignedIn.value) {
    router.push({hash: "#sign-in"});
    return;
  }
  if (props.joinLink) window.open(props.joinLink, "_blank");
}
</script>

<style scoped>
img {
  width: 14px;
}
a {
  height: 100%; /* expand to fill height and width of parent */
}
a.right {
  margin-left: 0.5em;
}
</style>
